"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.openAuth = exports.backFetchQuery = void 0;
var casdoor_js_sdk_1 = __importDefault(require("casdoor-js-sdk"));
// function getDeviceId() {
//   const excludes = {
//     // userAgent : true,
//     // audio : true,
//     // enumerateDevices : true,
//     // fonts : true,
//     // fontsFlash : true,
//     // webgl : true,
//     // canvas : true,
//   }
//   const options = { excludes }
//   return new Promise((resove) => {
//     Fingerprint2.get(options, function (components: any[]) {
//       // 参数
//       const values = components.map(function (component: any) {
//         return component.value
//       })
//       // console.log('参数们？',values,components)
//       // 指纹
//       const deviceId = Fingerprint2.x64hash128(values.join(''), 31)
//       const deviceName = components.find((m: any) => m.key === 'userAgent')?.value
//       console.log('获取到指纹？', deviceId, deviceName)
//       resove({ deviceId, deviceName })
//     })
//   })
// }
function backFetchQuery(href) {
    if (href.indexOf('?') === -1) {
        return {};
    }
    var url = href;
    var lastString = url.endsWith('#/');
    if (lastString) {
        url = url.substring(0, url.length - 2);
    }
    var ItemArr = [];
    var ItemObj = {};
    url
        .substring(url.lastIndexOf('?') + 1, url.length)
        .split('&')
        .map(function (item) { return ItemArr.push(item.split('=')); });
    // eslint-disable-next-line array-callback-return
    ItemArr.map(function (item) {
        // eslint-disable-next-line prefer-destructuring
        ItemObj[item[0]] = item[1];
    });
    return ItemObj;
}
exports.backFetchQuery = backFetchQuery;
// function getPathname(href: string) {
//   let url = href
//   const lastString = url.endsWith('#/')
//   if (lastString) {
//     url = url.substring(0, url.length - 2)
//   }
//   const urlObj = new URL(url)
//   return urlObj.hash ? urlObj.hash.split('?')[0] : urlObj.pathname
// }
// function getPathnameWithQuery(href: string) {
//   let url = href
//   const lastString = url.endsWith('#/')
//   if (lastString) {
//     url = url.substring(0, url.length - 2)
//   }
//   const urlObj = new URL(url)
//   const pathname = urlObj.hash ? urlObj.hash.split('?')[0] : urlObj.pathname
//   const query = url.split('?')[1] ? `${url.split('?')[1] ? '?' : ''}${url.split('?')[1]}` : ''
//   return pathname + query
// }
function getPathnameWithQueryDelete(href, removeKey, removeKeyMinor) {
    var url = href;
    var lastString = url.endsWith('#/');
    if (lastString) {
        url = url.substring(0, url.length - 2);
    }
    var urlObj = new URL(url);
    var pathname = urlObj.hash ? urlObj.hash.split('?')[0] : urlObj.pathname;
    var query = url.split('?')[1] ? "?".concat(url.split('?')[1]) : '';
    var params = new URLSearchParams(query);
    params.delete(removeKey);
    // eslint-disable-next-line no-unused-expressions
    removeKeyMinor && params.delete(removeKeyMinor);
    return "".concat(pathname).concat(params.toString() ? '?' : '').concat(params.toString());
}
function setAuthority(authority) {
    var proAuthority = typeof authority === 'string' ? authority.split(',') : authority || null;
    return localStorage.setItem('authority', JSON.stringify(proAuthority));
}
// export function backFetchQuery() {
//   const { location } = window
//   const query = new URLSearchParams(location.search)
//   const code = query.get('code')
//   const state = query.get('state')
//   let appname = ''
//   if (location.href.indexOf('scheduleForm') === -1) {
//     appname = 'teams'
//   } else {
//     appname = 'weekreport'
//   }
//   return { code, state, appname }
// }
function setToken(token, cb, redirectUrl, wxwork) {
    var tokennew = __assign({}, token);
    setAuthority('admin');
    localStorage.setItem('token', JSON.stringify(tokennew));
    localStorage.setItem('access-token', tokennew.token);
    if (redirectUrl && wxwork) {
        window.location.href = redirectUrl;
    }
    else {
        window.history.replaceState('', '', redirectUrl);
    }
    cb(true, '登录成功');
    // const backData = getDeviceId()
    // backData
    //   .then((res: any) => {
    //     console.log(res, 'backDatabackDatabackData', window.location, tokennew)
    //     tokennew.expiresAt = Number(tokennew.expiresAt)
    //     tokennew.timestamp = Number(tokennew.timestamp)
    //     tokennew.uid = Number(tokennew.uid)
    //     tokennew.device_id = res.deviceId
    //     tokennew.device_name = res.deviceName
    //     localStorage.setItem('token', JSON.stringify(tokennew))
    //     localStorage.setItem('access-token', tokennew.token)
    //     // window.location.href = location.pathname
    //     cb(true, '登录成功')
    //   })
    //   .catch((e) => {
    //     console.log(e, '指纹获取报错')
    //     cb(false, '指纹获取报错')
    //   })
}
function openAuth(skipConfig, wxworkLogin, uniteLogin, cb) {
    var location = window.location;
    var tokenObj = JSON.parse(localStorage.getItem('token') || '{}');
    var leftTime = 0;
    var tokenHash;
    var timestamp = Date.parse(new Date()) / 1000;
    if (tokenObj) {
        tokenHash = tokenObj.token;
        leftTime = tokenObj.expiresAt - timestamp;
    }
    // if (tokenObj.token && leftTime > 0) {
    //   cb(true, '登录成功')
    //   return
    // }
    var query = backFetchQuery(location.href);
    var hashToken = query.logintoken;
    hashToken = hashToken && decodeURIComponent(hashToken);
    var code = query.code, state = query.state, platform = query.platform, appid = query.appid;
    console.log(location.href, 'redirectUrlredirectUrl88', getPathnameWithQueryDelete(location.href, 'code', 'state'), query);
    if (platform === 'wxwork') {
        var redirectUrl = window.location.origin + getPathnameWithQueryDelete(location.href, 'platform', 'appid');
        console.log(redirectUrl, 'redirectUrlredirectUrl88', query);
        window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=".concat(appid, "&redirect_uri=").concat(redirectUrl, "&response_type=code&scope=snsapi_base&state=wxwork#wechat_redirect");
        cb(false, '跳转微信登录');
        return;
    }
    if (code) {
        if (state && state.includes('wxwork')) {
            // if (!tokenHash || leftTime <= 0) {
            wxworkLogin()
                .then(function (res) {
                var redirectUrl = getPathnameWithQueryDelete(location.href, 'code', 'state');
                console.log(redirectUrl, location.href, 'redirectUrlredirectUrl');
                if (res.data && res.code === 0) {
                    setToken({
                        expiresAt: res.data.expiresAt,
                        timestamp: res.data.timestamp,
                        token: res.data.token,
                        uid: res.data.uid,
                        name: res.data.name,
                        avatar: res.data.avatar,
                    }, cb, redirectUrl, 'wxwork');
                }
                else {
                    if (redirectUrl) {
                        // window.history.replaceState('', '', redirectUrl)
                        window.location.href = redirectUrl;
                    }
                    cb(false, res.msg || '登录失败');
                }
            })
                .catch(function () {
                var redirectUrl = getPathnameWithQueryDelete(location.href, 'code', 'state');
                if (redirectUrl) {
                    // window.history.replaceState('', '', redirectUrl)
                    window.location.href = redirectUrl;
                }
                cb(false, '请求错误');
            });
            // }
        }
        else {
            uniteLogin()
                .then(function (res) {
                var redirectUrl = getPathnameWithQueryDelete(location.href, 'code', 'state');
                if (res.data && res.code === 0) {
                    setToken({
                        expiresAt: res.data.expiresAt,
                        timestamp: res.data.timestamp,
                        token: res.data.token,
                        uid: res.data.uid,
                        name: res.data.name,
                        avatar: res.data.avatar,
                    }, cb, redirectUrl);
                }
                else {
                    if (redirectUrl) {
                        window.history.replaceState('', '', redirectUrl);
                    }
                    cb(false, res.msg || '登录失败');
                }
            })
                .catch(function () {
                var redirectUrl = getPathnameWithQueryDelete(location.href, 'code', 'state');
                if (redirectUrl) {
                    window.history.replaceState('', '', redirectUrl);
                }
                cb(false, '请求错误');
            });
        }
    }
    else if (hashToken) {
        console.log('===========打印企业微信登录code===8888333', code, hashToken);
        console.log("hashToken".concat(hashToken));
        var tokenData = JSON.parse(hashToken);
        if ((tokenData.token || tokenData.accessToken) && tokenData.uid && (tokenData.expiresAt || tokenData.expire) - timestamp > 0) {
            var redirectUrl = getPathnameWithQueryDelete(location.href, 'logintoken');
            setToken({
                expiresAt: tokenData.expire || tokenData.expiresAt,
                timestamp: tokenData.loginTimestamp,
                token: tokenData.accessToken || tokenData.token,
                uid: tokenData.uid,
                name: tokenData.name,
                avatar: tokenData.avatar,
            }, cb, redirectUrl);
        }
        else {
            var sdk = new casdoor_js_sdk_1.default(skipConfig);
            window.location.href = sdk.getSigninUrl();
        }
    }
    else if (leftTime <= 0 || !tokenHash) {
        var sdk = new casdoor_js_sdk_1.default(skipConfig);
        window.location.href = sdk.getSigninUrl();
    }
    else {
        cb(true, '已登录');
    }
}
exports.openAuth = openAuth;
//# sourceMappingURL=index.js.map